// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.input-wapper[data-v-244d79aa] {\n  position: relative;\n  width: 181px;\n  height: 40px;\n  background: #ffffff;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n}\n.range[data-v-244d79aa] {\n  font-size: 12px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
